import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faStar } from "@fortawesome/free-solid-svg-icons"

export const Star = (props) => {
  return <FontAwesomeIcon faIcon={faStar} {...props} />
}
